import { Eyebrow, Reveal } from './Reveal';

const STEPS = [
  {
    testid: 'difference-step-1',
    num: '01',
    title: 'Understand the requirement',
    desc: 'We clarify job responsibilities, location, salary or shift budget, deployment dates and expectations before proposing a solution.',
  },
  {
    testid: 'difference-step-2',
    num: '02',
    title: 'Match the service model',
    desc: 'Choose structured recruitment commitments, one-day and short-term staffing, or ongoing payroll and workforce administration.',
  },
  {
    testid: 'difference-step-3',
    num: '03',
    title: 'Coordinate with accountability',
    desc: 'Candidate screening, joining support, shift coordination, attendance records and agreed follow-up are handled through defined processes.',
  },
];

export default function Difference() {
  return (
    <section id="the-sania-difference" data-testid="difference-section" className="scroll-mt-28 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow index="07">The Sania difference</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
              Built for real workforce challenges.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
              We understand that every unfilled position, missed shift and payroll delay can affect business
              operations. Our solutions are designed around the practical details that matter to employers.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.testid} delay={i * 0.12} className="h-full">
              <article
                data-testid={s.testid}
                className="group relative h-full overflow-hidden rounded-[1.75rem] border border-slate-200/70 bg-white/70 p-8 transition-[background-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-lift"
              >
                <span aria-hidden="true" className="pointer-events-none absolute -right-2 -top-6 font-display text-[110px] font-extrabold leading-none text-outline transition-[color] duration-300 group-hover:text-lime/25">
                  {s.num}
                </span>
                <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.26em] text-lime-deep">{s.num}</p>
                <h3 className="relative mt-4 font-display text-xl font-extrabold text-ink">{s.title}</h3>
                <p className="relative mt-3 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                <span aria-hidden="true" className="absolute bottom-0 left-8 right-8 h-1 origin-left scale-x-0 rounded-full bg-lime transition-transform duration-500 group-hover:scale-x-100" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
